export const phoneNumber = require('awesome-phonenumber');
